<template>
    <b-list-group class="jgile-tree">
        <tree-node
            v-for="(node, key) in storedNodes"
            :selectable="selectable"
            :key="key"
            :node="node"
            :name="name"
            :options="mergedOptions"
            v-model="store"
            @nodeclicked="nodeclicked"
            @input="treeChanged"
            :int-val="intVal"
        >
        </tree-node>
        <template v-if="selectable && deselectAll">
            <b-list-group-item class="tree-node">
                <a href="#" class="text-sm" @click.prevent="doDeselectAll">Deselect All</a>
            </b-list-group-item>
        </template>
    </b-list-group>
</template>

<script>
import _ from 'lodash';
import TreeNode from './TreeNode';

export default {
    components: { TreeNode },
    props: {
        nodes: {
            type: Array,
            required: true,
        },
        name: {
            required: true,
        },
        value: {
            required: false,
        },
        selectable: {
            type: Boolean,
            default: true,
        },
        deselectAll: {
            type: Boolean,
            default: true,
        },
        options: {
            type: Object,
            default: () => {
                return {};
            },
        },
        intVal: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            store: [],
            storedNodes: null,
            showToggleAll: true,
            mergedOptions: {},
            defaultOptions: {
                depth: 0,
                keys: {
                    count: 'count',
                    path: 'path',
                    children: 'children',
                    name: 'name',
                    id: 'id',
                },
            },
        };
    },
    methods: {
        nodeclicked(node) {
            this.$emit('nodeclicked', node);
        },
        treeChanged() {
            this.$emit('input', this.store);
        },
        buildNodes(nodes, parentIds = []) {
            const self = this;

            return _.map(nodes, (node) => {
                let myId = _.get(node, this.mergedOptions.keys.id);
                let children = _.get(node, this.mergedOptions.keys.children, []);
                let childNodes = this.buildNodes(children, [...parentIds, myId]);
                _.set(node, 'parentIds', parentIds);
                _.set(
                    node,
                    'childIds',
                    _.flatMap(childNodes, (child) => {
                        let childId = _.get(child, this.mergedOptions.keys.id);
                        let childChildren = _.get(child, 'childIds', []);
                        return [...childChildren, self.intVal ? _.toInteger(childId) : childId];
                    }),
                );

                return node;
            });
        },
        doDeselectAll() {
            this.$emit('input', []);
        },
    },
    created() {
        this.storedNodes = this.buildNodes(this.nodes);
    },
    watch: {
        nodes: {
            deep: true,
            handler(newVal) {
                this.storedNodes = this.buildNodes(newVal);
            },
        },
        options: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.mergedOptions = _.merge({}, this.mergedOptions, this.defaultOptions, newVal);
            },
        },
        value: {
            deep: true,
            immediate: true,
            handler(newVal) {
                const values = Array.isArray(newVal) ? newVal : (newVal != null ? [newVal] : []);
                this.store = this.intVal ? _.map(values, (item) => _.toInteger(item)) : values;
            },
        },
    },
};
</script>

<style lang="scss"></style>
